import { type AccountRef, type PermissionKey } from '@aysar/contracts';

import { memberDetailPath, staffDetailPath } from '@/lib/route.constant';

/**
 * Where an account cell links (P27c2): a staff account to its staff page, a
 * member to the members page, and nowhere when the operator may not open
 * either. One rule for every queue, so a staff row never lands on a page that
 * would call it a member.
 */
export function accountPath(
  account: Pick<AccountRef, 'userId' | 'isStaff'> | null,
  can: (key: PermissionKey) => boolean,
): string | null {
  if (account === null || !can('members.read')) return null;

  return account.isStaff ? staffDetailPath(account.userId) : memberDetailPath(account.userId);
}
